export function mapCountryList(data) {
  if (data && data.length) {
    return data.map((v) => ({ id: v.id, name: v.country }));
  }
  return [];
}

export function mapCityList(data) {
  if (data && data.length) {
    return data.map((v) => ({ value: v.name, label: v.name }));
  }
  return [];
}

export function mapTitleList(data) {
  if (data && data.length) {
    return data.map((v) => ({ id: v.titleID, name: v.title }));
  }
  return [];
}

export function mapNewFormatCountryList(data) {
  if (data && data.length) {
    return data.map((v) => ({ value: v.country, label: v.country, id: v.id }));
  }
  return [];
}

export function mapDepreciationTypeList(data) {
  if (data && data.length) {
    return data.map((v) => ({ id: v.id, name: v.type, depreciationId: v.depreciationId }));
  }
  return [];
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/countryMapper.js